import {useMemo} from 'react';

import {
  useYandexAdsContextSelector,
  YandexAdsContextCommonSelectors,
} from '../context/YandexAdsContext';
import {AdFoxConfig, AdsApiAdapter, EmbedCodeBase} from '../types';
import {getAdvManager} from '../utils/getAdvManager';
import {getBaseAdFoxStatEventPayload} from '../utils/getBaseAdFoxStatEventPayload';

type Props = {
  adFoxConfig: AdFoxConfig;
  containerId: string;
  type: 'banner' | 'floorAd';
};

/** тут приводим все буйство рся/адфокса к простому единому интерфейсу */
export const useApiAdapter = ({
  adFoxConfig,
  containerId,
  type,
}: Props): AdsApiAdapter => {
  const emitAdFoxEvent = useYandexAdsContextSelector(
    YandexAdsContextCommonSelectors.getEmitAdFoxEvent,
  );
  return useMemo<AdsApiAdapter>(() => {
    if (adFoxConfig?.enabled) {
      let storedCode: EmbedCodeBase | null = null;
      return {
        init: ({
          callbacks: {onRender, onError, onStub, onAdFoxLoad, onFloorAdClose},
          adFoxCode,
        }) => {
          storedCode = adFoxCode;
          window.Ya?.adfoxCode?.create({
            ...adFoxCode,
            containerId,
            ...(adFoxConfig.lazyLoad &&
              type === 'banner' && {lazyLoad: adFoxConfig.lazyLoad}),
            onRender,
            onError,
            onLoad: (data) =>
              onAdFoxLoad?.(data.bundleParams?.data?.impressionData?.revenue),
            onStub,
            onClose: onFloorAdClose,
          });
        },
        refresh: (trigger, refreshNumber) => {
          window.Ya?.adfoxCode?.reload(containerId);
          if (storedCode) {
            emitAdFoxEvent({
              eventName: 'AdFoxRefreshList',
              payload: {
                refresh_number: `${refreshNumber}`,
                refresh_trigger: trigger,
                ...getBaseAdFoxStatEventPayload({
                  containerId,
                  code: storedCode,
                }),
              },
            });
          }
        },
        destroy: () => {
          window.Ya?.adfoxCode?.destroy(containerId);
        },
      };
    }

    let storedBlockId: string | null = null;
    return {
      init: ({
        callbacks: {onRender, onError, onStub, onFloorAdClose},
        blockId,
        devicePlatform,
      }) => {
        storedBlockId = blockId;
        getAdvManager()?.render(
          {
            blockId,
            renderTo: containerId,
            platform: devicePlatform,
            ...(type === 'floorAd' && {type}),
            onRender,
            onError,
            onClose: onFloorAdClose,
          },
          onStub,
        );
      },
      refresh: () => {
        if (storedBlockId) {
          getAdvManager()?.render(
            {
              blockId: storedBlockId,
              renderTo: containerId,
              ...(type === 'floorAd' && {type}),
              platform: getAdvManager().getPlatform(),
            },
            () => {
              console.warn('Floor ad refresh stub');
            },
          );
        }
      },
      destroy: () => {
        if (storedBlockId) {
          getAdvManager()?.destroy({
            blockId: storedBlockId,
            renderTo: containerId,
          });
        }
      },
    };
  }, [containerId, adFoxConfig, emitAdFoxEvent]);
};
